webpackJsonp([13],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_sdg1.c1da66f.svg";

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['AppConfig']))
});

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(508);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("4b6926cc", content, true, {});

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".login-header[data-v-9ea32018]{margin-top:30px;text-align:center;width:100%;float:left;font-style:normal;color:#212121;font-size:24px;font-family:ProximanovaBold}.text-style[data-v-9ea32018]{color:#212121;font-family:ProximanovaRegular;font-size:16px}.boldStyle[data-v-9ea32018]{font-family:ProximanovaBold}.support-text[data-v-9ea32018]{text-align:center}.about-container[data-v-9ea32018]{padding:10%}.about-container .about-logo[data-v-9ea32018]{text-align:center;padding-bottom:5%}.about-container .about-logo img[data-v-9ea32018]{width:15%}.about-container .about-text[data-v-9ea32018]{padding-bottom:5%}.about-container .about-links[data-v-9ea32018],.about-container .about-text p[data-v-9ea32018]{text-align:center}.about-container .about-links[data-v-9ea32018] :first-child{margin-right:25px}.about-container .about-links span[data-v-9ea32018]{color:#4558dd;font-family:ProximanovaRegular;font-size:14px;text-transform:uppercase;cursor:pointer}.about-container .about-links span[data-v-9ea32018]:hover{text-decoration:underline}.about-container .about-social-icons[data-v-9ea32018]{text-align:center;padding:5% 0}.about-container .about-social-icons p[data-v-9ea32018]{padding:2%}.about-container .about-social-icons[data-v-9ea32018] :nth-child(2){margin-left:0}.about-container .about-social-icons a[data-v-9ea32018]{margin-left:20px;opacity:.8}.about-container .about-social-icons a[data-v-9ea32018]:hover{opacity:1}.about-container .about-social-icons img[data-v-9ea32018]{-webkit-box-flex:1;-ms-flex:1;flex:1;width:25px;height:25px;cursor:pointer}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/About/About.vue"],"names":[],"mappings":"AACA,+BAA+B,gBAAgB,kBAAkB,WAAW,WAAW,kBAAkB,cAAc,eAAe,2BAA6B,CAClK,AACD,6BAA6B,cAAc,+BAAiC,cAAc,CACzF,AACD,4BAA4B,2BAA6B,CACxD,AACD,+BAA+B,iBAAiB,CAC/C,AACD,kCAAkC,WAAW,CAC5C,AACD,8CAA8C,kBAAkB,iBAAiB,CAChF,AACD,kDAAkD,SAAS,CAC1D,AACD,8CAA8C,iBAAiB,CAC9D,AAGD,+FAA+C,iBAAiB,CAC/D,AACD,4DAA6D,iBAAiB,CAC7E,AACD,oDAAoD,cAAc,+BAAiC,eAAe,yBAAyB,cAAc,CACxJ,AACD,0DAA0D,yBAAyB,CAClF,AACD,sDAAsD,kBAAkB,YAAY,CACnF,AACD,wDAAwD,UAAU,CACjE,AACD,oEAAoE,aAAe,CAClF,AACD,wDAAwD,iBAAiB,UAAW,CACnF,AACD,8DAA8D,SAAS,CACtE,AACD,0DAA0D,mBAAmB,WAAW,OAAO,WAAW,YAAY,cAAc,CACnI","file":"About.vue","sourcesContent":["\n.login-header[data-v-9ea32018]{margin-top:30px;text-align:center;width:100%;float:left;font-style:normal;color:#212121;font-size:24px;font-family:'ProximanovaBold'\n}\n.text-style[data-v-9ea32018]{color:#212121;font-family:\"ProximanovaRegular\";font-size:16px\n}\n.boldStyle[data-v-9ea32018]{font-family:\"ProximanovaBold\"\n}\n.support-text[data-v-9ea32018]{text-align:center\n}\n.about-container[data-v-9ea32018]{padding:10%\n}\n.about-container .about-logo[data-v-9ea32018]{text-align:center;padding-bottom:5%\n}\n.about-container .about-logo img[data-v-9ea32018]{width:15%\n}\n.about-container .about-text[data-v-9ea32018]{padding-bottom:5%\n}\n.about-container .about-text p[data-v-9ea32018]{text-align:center\n}\n.about-container .about-links[data-v-9ea32018]{text-align:center\n}\n.about-container .about-links[data-v-9ea32018] :nth-child(1){margin-right:25px\n}\n.about-container .about-links span[data-v-9ea32018]{color:#4558DD;font-family:\"ProximanovaRegular\";font-size:14px;text-transform:uppercase;cursor:pointer\n}\n.about-container .about-links span[data-v-9ea32018]:hover{text-decoration:underline\n}\n.about-container .about-social-icons[data-v-9ea32018]{text-align:center;padding:5% 0\n}\n.about-container .about-social-icons p[data-v-9ea32018]{padding:2%\n}\n.about-container .about-social-icons[data-v-9ea32018] :nth-child(2){margin-left:0px\n}\n.about-container .about-social-icons a[data-v-9ea32018]{margin-left:20px;opacity:0.8\n}\n.about-container .about-social-icons a[data-v-9ea32018]:hover{opacity:1\n}\n.about-container .about-social-icons img[data-v-9ea32018]{-webkit-box-flex:1;-ms-flex:1;flex:1;width:25px;height:25px;cursor:pointer\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"login-header"},[_vm._v("About")]),_vm._v(" "),_c('div',{staticClass:"about-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"about-text"},[_c('p',{staticClass:"text-style"},[_vm._v("\n        "+_vm._s(_vm.AppConfig.about.abouttext)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"support-text"},[_c('p',[_c('a',{staticClass:"text-style",attrs:{"href":_vm.AppConfig.about.website,"target":"_blank","rel":"noopener","aria-label":"Web link"}},[_vm._v("\n        "+_vm._s(_vm.AppConfig.about.website)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"about-social-icons"},[_c('p',{staticClass:"text-style boldStyle"},[_vm._v("Follow Us")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.facebook,"target":"_blank","rel":"noopener","aria-label":"facebook link"}},[_c('img',{attrs:{"src":__webpack_require__(40),"alt":"facebook logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.instagram,"target":"_blank","rel":"noopener","aria-label":"facebook link"}},[_c('img',{attrs:{"src":__webpack_require__(41),"alt":"instagram logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.twitter,"target":"_blank","rel":"noopener","aria-label":"twitter link"}},[_c('img',{attrs:{"src":__webpack_require__(42),"alt":"twitter logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.youtube,"target":"_blank","rel":"noopener","aria-label":"youtube link"}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":"youtube logo"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.AppConfig.about.social.pinterest,"target":"_blank","rel":"noopener","aria-label":"pinterest link"}},[_c('img',{attrs:{"src":__webpack_require__(44),"alt":"pinterest logo"}})])]),_vm._v(" "),_c('div',{staticClass:"about-links"},[_c('router-link',{attrs:{"to":{ name: 'TermsOfUse' }}},[_c('span',[_vm._v("terms of use")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'PrivacyPolicy' }}},[_c('span',[_vm._v("privacy policy")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-logo"},[_c('img',{attrs:{"src":__webpack_require__(202),"alt":"logo"}}),_vm._v(" "),_c('p',[_vm._v("1.0.0")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(349);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ea32018_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(509);
function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ea32018"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ea32018_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/13.ba700bf2e851e65f7e36.js